export default "__VITE_ASSET__D$NVAVWr__"